
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.173 0l2.112 2.921h3.22a2.824 2.824 0 012.825 2.816v1.236c1.188 0 2.165.974 2.165 2.158v2.132h-3.907c-1.637 0-2.983 1.342-2.983 2.974v2.894a2.976 2.976 0 002.983 2.974h3.907v2.342A2.559 2.559 0 0120.935 25H2.56A2.559 2.559 0 010 22.447V5.58c.053-1.475 1.293-2.66 2.798-2.66h6.283L13.173 0zm11.193 12.892c.344 0 .634.263.634.632v4.423c0 .342-.29.632-.634.632h-4.184a1.834 1.834 0 01-1.848-1.842v-2.003c0-1.026.818-1.842 1.848-1.842zM12.803 2.184l-6.679 4.79h10.111l-3.432-4.79z","fill":"var(--legend-c-text)"}})])
          )
        }
      }
    